import React, { useEffect, useState, useRef } from "react";
import "../../styles/profile.css";
import {
  FiUsers,
  FiBox,
  FiTrendingUp,
  FiUserX,
  FiSlash,
  FiPhone,
  FiCheck,
  FiX,
  FiEdit2,
} from "react-icons/fi";
import { FiMail, FiEye, FiEyeOff, FiLock } from "react-icons/fi";
import Card from "../ReusableComponent/Card";
import filter from "../../assets/filtericon.svg";
import {
  getWithTokenAPI,
  ImageUpload,
  postWithoutTokenAPI,
  postWithTokenAPI,
  putWithTokenAPI,
} from "../../util/Api";
import { useDispatch, useSelector } from "react-redux";
import {
  students_profile,
  update_profile,
  send_otp,
  verify_otp,
  dashboard,
} from "../../util/Apiendpoits";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { SafeToast } from "../Toast/ShowToast";
import { setProfileData } from "../../store/profileSlice";
import {
  CardSkeleton,
  ChartSkeleton,
  ProfileSkeleton,
} from "../ReusableComponent/TableSkeleton";
import Noimage from "../../assets/Noimage.jpg";
import { Filter, Sofa, X } from "lucide-react";
const ProfileComponent = () => {
  const { token, roleType, userId } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    role: "",
    price: "",
    profileimage: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [originalPhone, setOriginalPhone] = useState("");
  const [showPhoneEditModal, setShowPhoneEditModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [otpCountdown, setOtpCountdown] = useState(0);
  const [tempPhone, setTempPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [open, setOpen] = useState(false);
  // Image Crop States
  const [showCropModal, setShowCropModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({ aspect: 1 });
  const [completedCrop, setCompletedCrop] = useState(null);
  const imgRef = useRef(null);
  const otpInputRefs = useRef([]);

  const [cardsData, setCardsData] = useState([]);
  const [loginTab, setLoginTab] = useState("mobile");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const parseINR = (value) => value.replace(/[₹,\s]/g, "");

  // Format to Indian Rupee
  const formatINR = (value) => {
    if (!value) return "";
    return new Intl.NumberFormat("en-IN").format(value);
  };

  const buildCardsData = (data) => [
    {
      filterKey: "students",
      title: "Total Students",
      value: data?.totalStudents?.count ?? 0,
      change: data?.totalStudents?.change?.split(" ")[0] || "0%",
      changeType: data?.totalStudents?.change?.includes("Up") ? "up" : "down",
      changeText: data?.totalStudents?.change || "",
      icon: "users",
      color: "blue",
      navito: "/students",
    },
    {
      filterKey: "institutions",
      title: "Total Institutions",
      value: data?.totalInstitutions?.count ?? 0,
      change: data?.totalInstitutions?.change?.split(" ")[0] || "0%",
      changeType: data?.totalInstitutions?.change?.includes("Up")
        ? "up"
        : "down",
      changeText: data?.totalInstitutions?.change || "",
      icon: "school",
      color: "green",
      navito: "/institutions",
    },
    {
      filterKey: "states",
      title: "States",
      value: data?.totalStates?.count ?? 0,
      change: data?.totalStates?.key || "",
      changeType: "neutral",
      changeText: "",
      icon: "map",
      color: "orange",
    },
    {
      filterKey: "revenue",
      title: "Revenue",
      value: formatINR(data?.revenue?.total ?? 0),
      change: data?.revenue?.change?.split(" ")[0] || "0%",
      changeType: data?.revenue?.change?.includes("Up") ? "up" : "down",
      changeText: data?.revenue?.change || "",
      icon: "dollar",
      color: "purple",
    },
    {
      filterKey: "blocked",
      title: "Blocked Students",
      value: data?.blockedStudents?.count ?? 0,
      change: "",
      changeType: "neutral",
      changeText: "Blocked users",
      icon: "slash",
      color: "pink",
    },
    {
      filterKey: "nonactive",
      title: "Non - Active Users",
      value: data?.nonActiveStudents?.count ?? 0,
      change: "",
      changeType: "neutral",
      changeText: data?.nonActiveStudents?.criteria || "",
      icon: "user-x",
      color: "red",
    },
  ];

  const [filtersview, setFilters] = useState({
    students: true,
    institutions: true,
    states: true,
    revenue: true,
    blocked: true,
    nonactive: true,
  });

  const handleChange = (key) => {
    setFilters((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const [loading, setloadding] = useState(false);
  const fetchDashboardData = async () => {
    setloadding(true);
    try {
      const res = await getWithTokenAPI(token, dashboard);
      if (res?.success) {
        setCardsData(buildCardsData(res.data));
      } else {
        console.error("Failed to fetch dashboard data");
      }
    } catch (error) {
      console.error("Dashboard API error:", error);
    } finally {
      setloadding(false);
    }
  };
  useEffect(() => {
    fetchDashboardData();
  }, []);

  const dispatch = useDispatch();

  const fetchAdminProfile = async () => {
    try {
      setloadding(true);
      const res = await getWithTokenAPI(token, `${students_profile}${userId}`);

      if (res?.statusCode === 200) {
        setFormData({
          name: res?.data?.name,
          phone: res?.data?.phoneNumber,
          role: res?.data?.roleType,
          price: res?.data?.adminPrice,
          profileimage: res?.data?.profile_img,
          email: res?.data?.email,
        });
        dispatch(
          setProfileData({
            name: res.data.name,
            phone: res.data.phoneNumber,
            role: res.data.roleType,
            price: res.data.adminPrice,
            profileImage: res.data.profile_img,
            email: res.data.email,
            subexams: res.data.subexams,
            exams: res.data.exams
          }),
        );
        setOriginalPhone(res?.data?.phoneNumber);
      }
    } catch (error) {
      console.error("Profile fetch error", error);
    } finally {
      setloadding(false);
    }
  };

  useEffect(() => {
    fetchAdminProfile();
  }, [userId, token]);

  useEffect(() => {
    let timer;
    if (otpCountdown > 0) {
      timer = setTimeout(() => setOtpCountdown(otpCountdown - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [otpCountdown]);

  // Separate validation function that doesn't set state
  const isValidPhone = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phone) return false;
    if (!phoneRegex.test(phone)) return false;
    if (phone === originalPhone) return false;
    return true;
  };

  // Validation function that sets error state
  const validatePhoneAndSetError = (phone) => {
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phone) {
      setPhoneError("Phone number is required");
      return false;
    }
    if (!phoneRegex.test(phone)) {
      setPhoneError("Please enter a valid 10-digit phone number");
      return false;
    }
    if (phone === originalPhone) {
      setPhoneError("New phone number must be different from current number");
      return false;
    }
    setPhoneError("");
    return true;
  };

  const handleOpenPhoneEdit = () => {
    setTempPhone(formData.phone);
    setShowPhoneEditModal(true);
  };

  const handleClosePhoneEdit = () => {
    setShowPhoneEditModal(false);
    setTempPhone("");
    setPhoneError("");
  };

  const handleSendOtp = async () => {
    if (!validatePhoneAndSetError(tempPhone)) {
      return;
    }

    try {
      setIsSendingOtp(true);
      const res = await postWithTokenAPI(token, send_otp, {
        phoneNumber: tempPhone,
        roleType: roleType,
      });

      if (res?.statusCode === 200) {
        SafeToast.success("OTP sent successfully");
        setShowPhoneEditModal(false);
        setShowOtpModal(true);
        setOtpCountdown(60);
        // Focus first OTP input when modal opens
        setTimeout(() => {
          if (otpInputRefs.current[0]) {
            otpInputRefs.current[0].focus();
          }
        }, 100);
      } else {
        SafeToast.error(res?.message || "Failed to send OTP");
      }
    } catch (err) {
      SafeToast.error(err?.response?.data?.message || "Failed to send OTP");
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    const otpString = otp.filter(Boolean).join("");

    console.log(otp, "otpotp");
    console.log(otpString, "Please enter a valid");
    if (otpString.length !== 4) {
      SafeToast.error("Please enter a valid 4-digit OTP");
      return;
    }

    try {
      const res = await postWithTokenAPI(token, verify_otp, {
        phoneNumber: tempPhone,
        otp: otpString,
        roleType: roleType,
      });

      if (res?.statusCode === 200) {
        setIsOtpVerified(true);
        SafeToast.success("Phone number verified successfully");

        // Update phone number after successful verification
        setTimeout(async () => {
          try {
            const updateRes = await putWithTokenAPI(
              token,
              `${update_profile}/${userId}`,
              {
                phoneNumber: tempPhone,
              },
            );

            if (updateRes?.statusCode === 200) {
              SafeToast.success("Phone number updated successfully");
              setFormData((prev) => ({ ...prev, phone: tempPhone }));
              setOriginalPhone(tempPhone);
              setShowOtpModal(false);
              setOtp(["", "", "", ""]);
              setIsOtpVerified(false);
              setTempPhone("");
            }
          } catch (error) {
            SafeToast.error("Failed to update phone number");
          }
        }, 1500);
      } else {
        SafeToast.error(res?.message || "Invalid OTP");
        // Clear OTP on invalid
        setOtp(["", "", "", ""]);
        if (otpInputRefs.current[0]) {
          otpInputRefs.current[0].focus();
        }
      }
    } catch (err) {
      SafeToast.error(
        err?.response?.data?.message || "OTP verification failed",
      );
    }
  };
  const handleOtpChange = (index, value) => {
    if (!/^\d?$/.test(value)) return;

    setOtp((prev) => {
      const newOtp = [...prev];
      newOtp[index] = value;
      return newOtp;
    });

    // Auto focus next input
    if (value && index < 3) {
      otpInputRefs.current[index + 1]?.focus();
    }
  };

  // Handle OTP key down for backspace navigation
  const handleOtpKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpInputRefs.current[index - 1]?.focus();
    }
  };

  const handleOtpPaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 4);

    const newOtp = ["", "", "", ""];

    pasteData.split("").forEach((digit, i) => {
      newOtp[i] = digit;
    });

    setOtp(newOtp);

    // focus last filled input
    const lastIndex = pasteData.length - 1;
    if (otpInputRefs.current[lastIndex]) {
      otpInputRefs.current[lastIndex].focus();
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      SafeToast.error("Please select an image file");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      SafeToast.error("Image size should be less than 5MB");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      setSelectedImage(e.target.result);
      setShowCropModal(true);
      setCompletedCrop(null);
    };
    reader.readAsDataURL(file);
  };

  const onImageLoad = (img) => {
    imgRef.current = img;
    console.log("Image loaded:", img);
  };

  const handleCropComplete = async () => {
    if (!imgRef.current || !completedCrop) {
      SafeToast.error("No image or crop data available");
      return;
    }

    try {
      const image = imgRef.current;
      const canvas = document.createElement("canvas");
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;

      canvas.width = completedCrop.width * scaleX;
      canvas.height = completedCrop.height * scaleY;

      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        completedCrop.x * scaleX,
        completedCrop.y * scaleY,
        completedCrop.width * scaleX,
        completedCrop.height * scaleY,
        0,
        0,
        canvas.width,
        canvas.height,
      );

      canvas.toBlob(
        (blob) => {
          if (!blob) {
            SafeToast.error("Crop failed");
            return;
          }
          uploadImage(blob);
        },
        "image/jpeg",
        0.95,
      );
    } catch (error) {
      console.error("Crop error:", error);
      SafeToast.error("Failed to crop image");
    }
  };

  const uploadImage = async (blob) => {
    const formData = new FormData();
    formData.append("files", blob, "profile.jpg");
    for (let [key, value] of formData.entries()) {
      console.log(key, ":", value);
    }

    try {
      const res = await ImageUpload(
        `/upload_image?userId=${userId}&type=${roleType}`,
        formData,
        true,
      );

      if (res?.statusCode === 200 || res?.success) {
        SafeToast.success("Profile image uploaded successfully");
        const imageUrl = res.data?.[0]?.fileUrl;

        if (imageUrl) {
          setFormData((prev) => ({
            ...prev,
            profileimage: imageUrl,
          }));
        } else {
          console.warn("No image URL found in response:", res);
          SafeToast.error("Uploaded but no image URL received");
        }
      } else {
        SafeToast.error(res?.message || "Upload failed");
      }
    } catch (err) {
      console.error("Upload error:", err);
      SafeToast.error(err.message || "Upload failed");
    } finally {
      setShowCropModal(false);
      setSelectedImage(null);
      setCompletedCrop(null);
    }
  };
  const handleCancelCrop = () => {
    setShowCropModal(false);
    setSelectedImage(null);
    setCrop({ aspect: 1 });
    setCompletedCrop(null);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePassword = (password) => {
    return password.length >= 6;
  };

  const handleUpdateProfile = async () => {
    let isValid = true;

    if (!formData.email || !validateEmail(formData.email)) {
      setEmailError("Enter a valid email address");
      SafeToast.error("Enter a valid email address");

      isValid = false;
    } else {
      setEmailError("");
    }

    // if (!formData.password || !validatePassword(formData.password)) {
    //   setPasswordError("Password must be at least 6 characters");
    //   SafeToast.error("Password must be at least 6 characters");
    //   isValid = false;
    // } else {
    //   setPasswordError("");
    // }

    if (formData.password !== formData.confirmPassword) {
      setConfirmPasswordError("Passwords do not match");
      SafeToast.error("Passwords do not match");
      isValid = false;
    } else {
      setConfirmPasswordError("");
    }

    if (!isValid) {
      return;
    }

    try {
      const payload = {
        name: formData.name,
        adminPrice: formData.price,
        profile_img: formData.profileimage,
        email: formData.email,
        password: formData.password,
      };
      const res = await putWithTokenAPI(
        token,
        `${update_profile}/${userId}`,
        payload,
      );

      if (res?.statusCode === 200) {
        SafeToast.success("Profile updated successfully");
        fetchAdminProfile();
      }
    } catch (error) {
      SafeToast.error("Failed to update profile");
    }
  };

  const handlePhoneInputChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setTempPhone(value);
    validatePhoneAndSetError(value);
  };

  // Resend OTP function
  const handleResendOtp = async () => {
    if (otpCountdown > 0) return;

    try {
      setIsSendingOtp(true);
      const res = await postWithTokenAPI(token, send_otp, {
        phoneNumber: tempPhone,
        roleType: roleType,
      });

      if (res?.statusCode === 200) {
        SafeToast.success("OTP resent successfully");
        setOtpCountdown(60);
        setOtp(["", "", "", ""]);
        if (otpInputRefs.current[0]) {
          otpInputRefs.current[0].focus();
        }
      } else {
        SafeToast.error(res?.message || "Failed to resend OTP");
      }
    } catch (err) {
      SafeToast.error(err?.response?.data?.message || "Failed to resend OTP");
    } finally {
      setIsSendingOtp(false);
    }
  };

  useEffect(() => {
    const isAnyModalOpen =
      showPhoneEditModal || showOtpModal || (showCropModal && selectedImage);

    if (isAnyModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [showPhoneEditModal, showOtpModal, showCropModal, selectedImage]);

  if (loading) {
    return (
      <>
        <ProfileSkeleton />
        <div className="dashboard-grid-shimmer">
          {["blue", "green", "orange", "purple", "blue", "green", "orange"].map(
            (color, index) => (
              <CardSkeleton key={index} color={color} />
            ),
          )}
        </div>
      </>
    );
  }
  return (
    <div className="profile-page">
      <h2 className="page-title">Profile</h2>

      <div className="profile-card">
        <div className="profile-image">
          <label htmlFor="profileUpload">
            <img
              src={formData.profileimage || Noimage}
              alt="profile"
              className="profile-img"
            />
            <div className="upload-overlay">
              <span>Change Photo</span>
            </div>
          </label>

          <input
            id="profileUpload"
            type="file"
            accept="image/*"
            hidden
            onChange={handleImageChange}
          />
        </div>

        <div className="profile-info">
          <div className="login-tabs-profile">
            <button
              className={
                loginTab === "mobile" ? "tab-profile active" : "tab-profile"
              }
              onClick={() => setLoginTab("mobile")}
            >
              Login Details
            </button>
            <button
              className={
                loginTab === "email" ? "tab-profile active" : "tab-profile"
              }
              onClick={() => setLoginTab("email")}
            >
              Change Password
            </button>
          </div>

          {loginTab === "email" && (
            <>
              <div className="dark-input-wrap">
                <span className="dark-input-icon left">
                  <FiLock />
                </span>

                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  className="dark-input"
                  value={formData.password}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      password: e.target.value,
                    }))
                  }
                />

                <span
                  className="dark-input-icon right"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <FiEye /> : <FiEyeOff />}
                </span>
              </div>
              {passwordError && (
                <span className="dark-error">{passwordError}</span>
              )}

              {/* CONFIRM PASSWORD */}
              <div className="dark-input-wrap">
                <span className="dark-input-icon left">
                  <FiLock />
                </span>

                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  className="dark-input"
                  value={formData.confirmPassword}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      confirmPassword: e.target.value,
                    }))
                  }
                />

                <span
                  className="dark-input-icon right"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <FiEye /> : <FiEyeOff />}
                </span>
              </div>
              {confirmPasswordError && (
                <span className="dark-error">{confirmPasswordError}</span>
              )}
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  marginTop: "6.6vh",
                }}
              >
                <button className="update-btn" onClick={handleUpdateProfile}>
                  UPDATE
                </button>
              </div>
            </>
          )}

          {loginTab === "mobile" && (
            <div>
              <div className="info-rowprofile">
                <input
                  type="text"
                  name="name"
                  placeholder="Name"
                  value={formData.name}
                  onChange={(e) =>
                    setFormData((prev) => ({ ...prev, name: e.target.value }))
                  }
                />

                <div className="input-box-otp">
                  <span className="icon">
                    <FiPhone />
                  </span>
                  <input type="tel" value={formData.phone} readOnly />
                  <button
                    className="edit-phone-btn"
                    onClick={handleOpenPhoneEdit}
                  >
                    <FiEdit2 /> Edit
                  </button>
                </div>
              </div>

              <div className="info-rowprofile">
                <div className="input-box-otprow">
                  <span className="dark-input-icons left">
                    <FiMail />
                  </span>

                  <input
                    type="email"
                    placeholder="Email"
                    className="dark-input"
                    value={formData.email}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFormData((prev) => ({ ...prev, email: value }));
                    }}
                    style={{
                      borderRadius: "0px 10px 10px 0px",
                      paddingLeft: "5px",
                      outline: "none",
                    }}
                  />
                </div>
                {/* <br />
                {emailError && <span className="dark-error">{emailError}</span>} */}

                <input
                  type="text"
                  name="role"
                  placeholder="Role"
                  value={formData.role}
                  readOnly
                  className="readonly-input"
                />
              </div>

              <div className="price-update">
                <div className="price-box">
                  Price :
                  <input
                    type="text"
                    name="price"
                    value={formatINR(formData.price)}
                    onChange={(e) => {
                      const rawValue = parseINR(e.target.value);
                      if (!isNaN(rawValue)) {
                        setFormData((prev) => ({
                          ...prev,
                          price: rawValue,
                        }));
                      }
                    }}
                    inputMode="numeric"
                    placeholder="Enter amount"
                  />
                </div>
                <button className="update-btn" onClick={handleUpdateProfile}>
                  UPDATE
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="filter-iconprofile" onClick={() => setOpen(true)}>
          <img src={filter}></img>
        </div>
      </div>
      {open && (
        <div className="filter-overlay">
          <div className="filter-dialog">
            <div className="filter-header">
              <h3>Dashboard Filters</h3>
              <X onClick={() => setOpen(false)} />
            </div>

            <div className="filter-body">
              <label>
                <input
                  type="checkbox"
                  checked={filtersview.students}
                  onChange={() => handleChange("students")}
                />
                Total Students
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={filtersview.institutions}
                  onChange={() => handleChange("institutions")}
                />
                Total Institutions
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={filtersview.states}
                  onChange={() => handleChange("states")}
                />
                States
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={filtersview.revenue}
                  onChange={() => handleChange("revenue")}
                />
                Revenue
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={filtersview.blocked}
                  onChange={() => handleChange("blocked")}
                />
                Blocked Students
              </label>

              <label>
                <input
                  type="checkbox"
                  checked={filtersview.nonactive}
                  onChange={() => handleChange("nonactive")}
                />
                Non-Active Users
              </label>
            </div>
          </div>
        </div>
      )}
      <div className="stats-grid">
        {cardsData
          .filter((card) => filtersview[card.filterKey])
          .map((card, index) => (
            <Card
              key={index}
              title={card.title}
              value={card.value}
              icon={card.icon}
              color={card.color}
              change={card.change}
              changeType={card.changeType}
              changeText={card.changeText}
              navito={card.navito}
            />
          ))}
      </div>

      {/* Phone Edit Modal */}
      {showPhoneEditModal && (
        <div className="modal-overlay">
          <div className="phone-edit-modal">
            <div className="modal-header">
              <div className="modal-title-section">
                <FiPhone className="modal-title-icon-profile" />
                <h3>Update Phone Number</h3>
              </div>
              <button className="close-modal" onClick={handleClosePhoneEdit}>
                <FiX />
              </button>
            </div>
            <div className="modal-body">
              <div className="current-phone-info">
                <div>
                  <div className="current-phone-label">
                    Current Phone Number:
                  </div>
                  <div className="current-phone-value">{formData.phone}</div>
                </div>
                <button
                  className="otp-btn-large"
                  onClick={handleSendOtp}
                  disabled={!isValidPhone(tempPhone) || isSendingOtp}
                >
                  {isSendingOtp ? (
                    <>
                      <span className="spinner"></span>
                      SENDING...
                    </>
                  ) : (
                    "SEND OTP"
                  )}
                </button>
              </div>

              <div className="form-group">
                <label className="form-label">New Phone Number</label>
                <div className="input-box-with-otp">
                  <div className="phone-input-wrapper">
                    <span className="country-code">+91</span>
                    <input
                      type="tel"
                      value={tempPhone}
                      onChange={handlePhoneInputChange}
                      placeholder="Enter 10-digit phone number"
                      maxLength={10}
                      className="phone-input"
                      autoFocus
                    />
                  </div>
                </div>
                {phoneError && (
                  <div className="error-message">{phoneError}</div>
                )}
                <div className="phone-edit-note">
                  An OTP will be sent to verify the Current phone number
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="modal-cancel-btn"
                onClick={handleClosePhoneEdit}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* OTP Verification Modal */}
      {showOtpModal && (
        <div className="modal-overlay">
          <div className="otp-modal">
            <div className="modal-header">
              <div className="modal-title-section">
                <FiCheck className="modal-title-icon verified" />
                <h3>Verify OTP</h3>
              </div>
              <button
                className="close-modal"
                onClick={() => {
                  setShowOtpModal(false);
                  setOtp(["", "", "", ""]);
                  setIsOtpVerified(false);
                }}
                disabled={isOtpVerified}
              >
                <FiX />
              </button>
            </div>
            <div className="modal-body">
              <div className="otp-info">
                <p>Enter the 4-digit verification code sent to</p>
                <div className="otp-phone-number">+91 {tempPhone}</div>
              </div>

              <div className="otp-box-container">
                <p className="otp-label">Enter OTP</p>
                <div className="otp-inputs-group" onPaste={handleOtpPaste}>
                  {[0, 1, 2, 3].map((index) => (
                    <input
                      key={index}
                      ref={(el) => (otpInputRefs.current[index] = el)}
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      maxLength="1"
                      value={otp[index]}
                      onChange={(e) => handleOtpChange(index, e.target.value)}
                      onKeyDown={(e) => handleOtpKeyDown(index, e)}
                      className="otp-digit-input"
                      autoFocus={index === 0}
                      disabled={isOtpVerified}
                    />
                  ))}
                </div>

                {otpCountdown > 0 ? (
                  <div className="otp-timer">
                    Resend OTP in{" "}
                    <span className="timer-count">{otpCountdown}s</span>
                  </div>
                ) : (
                  <button
                    className="resend-otp-link"
                    onClick={handleResendOtp}
                    disabled={isOtpVerified}
                  >
                    Resend OTP
                  </button>
                )}
              </div>

              {isOtpVerified ? (
                <div className="verification-success">
                  <FiCheck className="success-icon" />
                  <span>Phone number verified successfully!</span>
                </div>
              ) : (
                <div className="otp-actions">
                  <button
                    className="verify-otp-btn"
                    onClick={handleVerifyOtp}
                    disabled={otp.some((digit) => digit === "")}
                  >
                    VERIFY OTP
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Image Crop Modal */}
      {showCropModal && selectedImage && (
        <div className="modal-overlay">
          <div className="crop-modal">
            <div className="modal-header">
              <h3>Crop Profile Image</h3>
              <button className="close-modal" onClick={handleCancelCrop}>
                <FiX />
              </button>
            </div>
            <div className="modal-body">
              <div className="crop-container">
                <ReactCrop
                  crop={crop}
                  onChange={(c) => setCrop(c)}
                  onComplete={(c) => setCompletedCrop(c)}
                  aspect={1}
                  circularCrop={true}
                >
                  <img
                    src={selectedImage}
                    ref={imgRef}
                    onLoad={(e) => onImageLoad(e.target)}
                    alt="Crop preview"
                    className="crop-image"
                  />
                </ReactCrop>
              </div>
              <div className="crop-actions">
                <button className="cancel-crop-btn" onClick={handleCancelCrop}>
                  Cancel
                </button>
                <button
                  className="apply-crop-btn"
                  onClick={handleCropComplete}
                  disabled={!completedCrop}
                >
                  Apply Crop
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileComponent;
